import { Injectable } from "@angular/core";
import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from "@angular/router";
import { ObservableDataService } from "../../../services/core/observable-data.service";
import * as toastr from "toastr";
import { Observable } from "rxjs";

@Injectable()
export class ModulePermissionGuard implements CanActivate {
    defaultAction = "view";

    constructor(private router: Router, private ods: ObservableDataService) {}

    canActivate(
        route: ActivatedRouteSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        const moduleName = route.parent.routeConfig["_loadedInjector"].source;
        const currentUser = this.ods.getLoggedUser();

        if (currentUser) {
            const { modules } = currentUser;

            if (currentUser.companyIsSaaSOwner) {
                return true;
            }

            if ("data" in route) {
                const routeData = route.data;
                const action =
                    "action" in routeData
                        ? routeData.action
                        : this.defaultAction;

                if (moduleName in modules) {
                    if (
                        modules[moduleName][this.defaultAction] &&
                        modules[moduleName][action]
                    ) {
                        return true;
                    }
                }
            }
        }

        toastr.warning("You cannot access this page.", "Request Denied");
        this.router.navigate(["/"]);
        return false;
    }
}
